import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import { usePermissionContext } from '@contexts/PermissionContext';
import { UPERCUT_PERMISSION_SYSTEM_CHANGED, UPERCUT_USER_ROLE_CHANGED } from '@gql/upercut-permissions';

export const usePermissionSubscription = (upercutId?: string) => {
    const { refresh } = usePermissionContext();

    const { data: systemData } = useSubscription(UPERCUT_PERMISSION_SYSTEM_CHANGED);
    const { data: roleData } = useSubscription(UPERCUT_USER_ROLE_CHANGED, {
        variables: upercutId ? { upercutId } : undefined,
        skip: !upercutId,
    });

    useEffect(() => {
        if (systemData || roleData) {
            refresh();
        }
    }, [systemData, roleData, refresh]);
};
